export const BACKEND_API_URL = import.meta.env.VITE_API_BACKEND_ENDPOINT ?? '';
